module.exports = __webpack_public_path__ + "static/media/bus-top.84eb4c68.svg";